import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { post } from "../networking/Server";
import { Spin, Carousel, Input } from "antd";
import {
  FireTwoTone,
  StarFilled,
  FieldTimeOutlined,
    PlusCircleFilled,
MinusCircleOutlined,
    LoadingOutlined
} from "@ant-design/icons";
import {calculatePrice, priceText} from "../functions/priceText";
import { languageText } from "../functions/language";
import Header from "./Thema/header";
import { string } from "../constants/languages";
import {error, success} from "../functions/toast";
import { checkOptions } from "../functions/checkOption";
import ProductOptions from "../Components/ProductOptions";
import {MStore} from "../networking/stores/MainStore";
import {controlOrderSystem} from "../functions/controlOrderSystem";

let color = "#31c149";

function Product(params) {
  const [data, setData] = useState({});
  const [cafe, setCafe] = useState({});
  const [count, setCount] = useState(1);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);


    const history = useHistory();
  let { cafe_id, app_id, product_id } = useParams();

  cafe_id = parseInt(window.atob(cafe_id))

  if (!product_id) {
    product_id = params["product_id"];
  }

  useEffect(() => {
      setCount(1)
      setNote("")
      setLoading(false)
    setData({});
    if (!product_id) return;

    post("qr/get_product", { product_id, app_id }).then((res) => {
      if (res.result) {
        try {
          color = JSON.parse(res.product["cafe"]["colors"]).primary;
        } catch (e) {}

        setData(res.product);
        setCafe(res.product["cafe"]);
      } else {
        if (params["onBack"]) {
          params.onBack();
        } else {
          history.goBack();
        }
      }
    });
  }, [product_id]);

  function addBasket( product_id, cafe_id, options, count, price, score, note,) {
      setLoading(true)
      post("qr/api/basket/add", {
          app_id,
          product_id,
          cafe_id,
          options,
          count,
          price,
          score,
          note,
      }).then(async (res) => {
          setLoading(false)
          if (res.result) {
              success(string.basarili, string.urunsepetinizeeklendi)
              MStore.setBasketCount(MStore.basket_count+count)
              if (params["onBack"]) {
                  params.onBack();
              } else {
                  history.goBack();
              }
          } else {
              error()
          }
      });
  }

  if (!data || !data["product_id"]) {
    return (
      <div
        style={{
          overflow: "scroll",
          padding: "0 0 100px 0",
          backgroundColor: "white",
          flex: 1,
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    );
  }

  let {
    images,
    score,
    name,
    description,
    price,
    discount_price,
    calorie,
    time,
    options,
  } = data;
  try {
    images = JSON.parse(images);
    if (!images) throw "";
  } catch (e) {
    images = [];
  }

    const total_price = calculatePrice(price, discount_price, count, options);


    return (
    <div className="hide-scrollbar" style={{ display: "grid" }}>
      <Header
        id={"product"}
        cafe={cafe}
        color={color}
        title={languageText(name)}
        onBack={() => {
          if (params["onBack"]) {
            params.onBack();
          } else {
            history.goBack();
          }
        }}
      />

      <div id={"scroll_product"} className="scroll">
        <Carousel className="slider" autoplay>
          {images.map((url, i) => (
            <div key={i}>
              <img
                alt={url}
                style={{ objectFit: "cover" }}
                width={"100%"}
                className="slider"
                src={url}
              />
            </div>
          ))}
        </Carousel>

        <div style={{ padding: 20 }}>
          <div style={{ display: "flex" }}>
            {score ? (
              <div
                style={{
                  fontWeight: "bold",
                  borderRadius: 10,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                  fontSize: 15,
                  padding: "5px 10px",
                  alignSelf: "center",
                  color: "white",
                  backgroundColor: "#fb3d67",
                }}
              >
                {score}
                <StarFilled />
              </div>
            ) : null}
            <div
              style={{ margin: "0 0 0 10px", fontWeight: "bold", fontSize: 24 }}
            >
              {languageText(name)}
            </div>
          </div>

          <span
            style={{
              display: "flex",
              whiteSpace: "break-spaces",
              fontSize: 16,
              lineHeight: 1.3,
              margin: "8px 0 0 0",
            }}
          >
            {languageText(description)}
          </span>

          <div>
            <div
              style={{
                color,
                fontSize: 25,
                fontWeight: "bold",
                display: "flex",
                margin: "10px 0 0 0 ",
                gap: 8,
              }}
            >
              <span>
                {discount_price
                  ? priceText(discount_price, cafe.currency)
                  : priceText(price, cafe.currency)}
              </span>
              {discount_price ? (
                <span
                  style={{
                    fontSize: 16,
                    textDecoration: "line-through",
                  }}
                >
                  {priceText(price, cafe.currency)}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        {calorie ? (
          <div>
            <div
              style={{
                padding: "15px 20px 15px 20px",
                fontWeight: "bold",
                alignItems: "center",
                fontSize: 14,
                background: "#f0f0f0",
              }}
            >
              {string.kalori}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                padding: 20,
                fontSize: 24,
              }}
            >
              <FireTwoTone twoToneColor={"#FF8F00"} />
              <div
                style={{
                  fontSize: 16,
                  fontWeight: "400",
                  margin: "0 0 0 10px",
                }}
              >
                {languageText(calorie)}
              </div>
            </div>
          </div>
        ) : null}

        {time ? (
          <div>
            <div
              style={{
                padding: "15px 20px 15px 20px",
                fontWeight: "bold",
                fontSize: 14,
                background: "#f0f0f0",
              }}
            >
              {string.hazirlanmasuresi}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: 20,
                fontSize: 24,
              }}
            >
              <FieldTimeOutlined style={{ color: "#6D4C41" }} />
              <div
                style={{
                  fontSize: 16,
                  fontWeight: "400",
                  margin: "0 0 0 10px",
                }}
              >
                {languageText(time)}
              </div>
            </div>
          </div>
        ) : null}


        {Array.isArray(options) && options.length ? (
          <div>
            <div
              style={{
                padding: "15px 20px 15px 20px",
                fontWeight: "bold",
                fontSize: 14,
                background: "#f0f0f0",
              }}
            >
              {string.opsiyonlar}
            </div>
            <div
              style={{
                padding: 20,
              }}
            >
                <ProductOptions
                    justShow={!controlOrderSystem()}
                    free={false}
                    disabled={false}
                    size={1}
                    color={color}
                    data={options}
                    currency={cafe["currency"]}
                    onPress={(_options) => {
                        data["options"] = _options;
                        setData({ ...data });
                    }}
                />
            </div>
          </div>
        ) : null}

          {
              controlOrderSystem()?
                  <div>
                      <div
                          style={{
                              padding: "15px 20px 15px 20px",
                              fontWeight: "bold",
                              fontSize: 14,
                              background: "#f0f0f0",
                          }}
                      >
                          {string.eklemekistediginiznot}
                      </div>
                      <div
                          style={{
                              padding: 20,
                          }}
                      >

                          <Input.TextArea
                              value={note}
                              onChange={(event)=>{setNote(event.target.value)}}
                              style={{background: "#f0f0f0",borderWidth:0}} maxLength={500} rows={5}
                          />
                      </div>
                  </div>:null
          }

          {
              controlOrderSystem()?
                  <div style={{ display:'flex', flexDirection:'row',justifyContent:'space-around',alignItems:'center', backgroundColor:color,margin:15,padding:3,borderRadius:10}}>
                      <div style={{display:'flex',flex:1.5,flexDirection:'row',justifyContent:'space-around',alignItems:'center', backgroundColor:'white',margin:3,padding:5,borderRadius:10}}>
                          <div style={{padding:10}} onClick={()=>{if(count>1) setCount(count-1)}}><MinusCircleOutlined style={{color,fontSize:25}}/></div>
                          <div><h2 style={{margin:0,marginBottom:2,fontWeight:'bold'}}>{count}</h2></div>
                          <div style={{padding:10}} onClick={()=>{if(count<10)setCount(count+1)}}><PlusCircleFilled  style={{color,fontSize:25}}/></div>
                      </div>
                      {
                          loading?
                              <div
                                  style={{display:'flex',  flex:1,flexDirection:'column',borderLeft:'1px solid white', justifyContent:'center',alignItems:'center',marginLeft:0,marginRight:4, margin:10,padding:5}}
                              >
                                  <LoadingOutlined style={{color:'white',fontSize:20,fontWeight:'bold'}}/>
                              </div>:
                              <div
                                  onClick={()=>{
                                      if(loading)
                                          return;
                                      let check = checkOptions(options);
                                      if (check) {
                                          error(check, string.bosolamaz);
                                          return;
                                      }

                                      addBasket(product_id,cafe_id,options,count,total_price,0,note)
                                  }}
                                  style={{display:'flex',  flex:1,flexDirection:'column',borderLeft:'1px solid white', justifyContent:'center',alignItems:'center',marginLeft:0,marginRight:4, margin:10,padding:5}}
                              >
                                  <h3 style={{color:'white',fontWeight:'bold',margin:0}}>{priceText(total_price, cafe.currency)}</h3>
                                  <h4 style={{color:'white',margin:0}}>{string.sepeteekle}</h4>
                              </div>
                      }
                  </div>:null
          }

        {cafe?.ios_id && !controlOrderSystem() ? (
          <div
            style={{
              margin: 20,
              backgroundColor: color,
              borderRadius: 5,
              padding: 10,
            }}
          >
            <a
              href={
                /iPhone|iPad|iPod/i.test(navigator.userAgent)
                  ? "https://apps.apple.com/tr/app/" + cafe?.ios_id
                  : "https://play.google.com/store/apps/details?id=" + app_id
              }
              target="_blank"
              style={{
                cursor: "pointer",
                color,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 5,
                backgroundColor: "white",
                padding: 20,
                fontSize: 18,
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              <img
                width={64}
                height={64}
                src="data:image/svg+xml;base64,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"
              />
              {string.sepeteeklemekicinuygulamayiindir}
            </a>
          </div>
        ) : null}


        <div style={{ height: "100px" }} />
      </div>

    </div>
  );
}

export default Product;
